import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { BookMeetingForm } from 'Components/Blocks/Forms'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_SECTION_PY } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container, Content } from './styles'

function BookMeetingSection() {
  const { isMobile, isTablet } = useResponsiveLayout()

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container px={LANDING_CONTENT_PX} py={LANDING_SECTION_PY}>
          <Content
            flexDirection={['column', 'column', 'column', 'column', 'row']}
            gap={[9, 9, 9, 9, 13]}
          >
            <SubsectionTitle
              centered={isMobile || isTablet}
              maxWidth={824}
              paragraph="Choose a convenient time to connect with us. During the meeting we’ll answer your questions and walk you through the benefits of membership."
              subtitle="Schedule a meeting with our team to discuss membership"
              title="Book a Meeting"
            />

            <Column noShrink width="388px">
              <BookMeetingForm />
            </Column>
          </Content>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default BookMeetingSection
